import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=15c2d9ca&"
import script from "./TransactionsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c2d9ca')) {
      api.createRecord('15c2d9ca', component.options)
    } else {
      api.reload('15c2d9ca', component.options)
    }
    module.hot.accept("./TransactionsList.vue?vue&type=template&id=15c2d9ca&", function () {
      api.rerender('15c2d9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/TransactionsList.vue"
export default component.exports